import User from '@modules/User';
import {client} from '@core/GraphQLProvider';
import {
    GetOrder,
    GetOrderDetailHtml,
    GetOrderDetailWithTrackingHtml,
    GetOrderHeaders,
    GetOrders,
    GetPastPurchases,
    UpdatePendingOrderState
} from './query.graphql';

const OrdersService = {

    async getOrderHeaders ( {numberOfDays, numberOfRows} = {numberOfDays: 180, numberOfRows: 50} ) {
        const resp = await client.query( {
            query: GetOrderHeaders,
            variables: {numberOfDays, numberOfRows}
        } );

        return resp.data;
    },

    async getOrders ( {numberOfDays, numberOfRows} = {numberOfDays: 180, numberOfRows: 50} ) {
        const resp = await client.query( {
            query: GetOrders,
            variables: {numberOfDays, numberOfRows}
        } );

        return resp.data.orders;
    },

    async getOrderById ( {orderNumber} = {} ) {
        const resp = await client.query( {
            fetchPolicy: 'no-cache',
            query: GetOrder,
            variables: {orderNumber: parseInt( orderNumber, 10 )}
        } );

        return resp.data.order;
    },

    async getOrderDetailsHtml ( {orderNumber} = {} ) {
        const resp = await client.query( {
            fetchPolicy: 'no-cache',
            query: GetOrderDetailHtml,
            variables: {orderNumber}
        } );

        return resp.data.orderHtml.orderDetailHtml;
    },

    async getOrderDetailsAndTrackingHtml ( {orderNumber} = {} ) {
        const resp = await client.query( {
            fetchPolicy: 'no-cache',
            query: GetOrderDetailWithTrackingHtml,
            variables: {orderNumber}
        } );

        return resp.data.orderHtml.orderDetailWithShippingHtml;
    },

    async getPastPurchases ( resultLimit = 12, months = 9, filterCart = true ) {
        if ( !User.isLogged() ) {
            console.warn( '[OrdersService]:getPastPurchases - User is not logged in, returning empty list' );
            return [];
        }

        const resp = await client.query( {
            query: GetPastPurchases,
            variables: {
                resultLimit,
                months,
                filterCart
            }
        } );

        return resp.data.suggestedProducts;
    },

    async updateOrderPO ( {orderNumber, poNumber} ) {
        if ( !poNumber ) {
            throw new Error( `OrdersService.updateOrderPO missing required param "poNumber"; received ${poNumber} instead` );
        }

        const input = {
            orderNumber,
            poNumber
        };

        const resp = await client.mutate( {
            mutation: UpdatePendingOrderState,
            variables: {input}
        } );

        return resp.data.updatePendingOrder;
    },

    async approveOrder ( {orderNumber, poNumber} ) {
        const input = {
            orderNumber,
            poNumber,
            orderStatus: 'APPROVED'
        };

        const resp = await client.mutate( {
            mutation: UpdatePendingOrderState,
            variables: {input}
        } );

        return resp.data.updatePendingOrder;
    },

    async rejectOrder ( {orderNumber, adminNotes} ) {
        const input = {
            orderNumber,
            adminNotes,
            orderStatus: 'REJECTED'
        };

        const resp = await client.mutate( {
            mutation: UpdatePendingOrderState,
            variables: {input}
        } );

        return resp.data.updatePendingOrder;
    }

};

export default OrdersService;
